module.exports = __webpack_public_path__ + "static/media/register.1977eb1f.jpg";